/* Other */
import { DEFAULT_AGE_RATING } from '../utils/constants';

import backendService from './backendService';

export function getProfilesAPI() {
  return backendService.customer.v1.getProfiles();
}

export function getProfileAPI(profileId) {
  return backendService.customer.v1.getProfile(profileId);
}

export function createProfileAPI(profile) {
  /* Forcing the ageRating to 18 as default, if it comes up empty in any request. */
  const valueAgeRating = profile?.ageRating || DEFAULT_AGE_RATING;

  const objCreateProfile = {
    ...profile,
    ageRating: valueAgeRating,
  };
  return backendService.customer.v1.createProfile(objCreateProfile);
}

export function deleteProfileAPI(profileId) {
  return backendService.customer.v1.deleteProfile(profileId);
}

export function editProfileAPI(profileId, profile) {
  return backendService.customer.v1.patchProfile(profileId, profile);
}
